import React from 'react'
import axios from '@/utils/myaxios'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { tableSummaries, isMobileDevice } from '@/utils/utils'
import {
    statusList,
    blindTypesList,
    bonusTypesList,
    publishTypeList,
    weekList,
    languageTypeList,
} from '@/utils/constant'
import {
    Button,
    Table,
    message,
    Modal,
    Select,
    InputNumber,
    Input,
    Form,
    Switch,
    DatePicker,
    TimePicker,
    Slider,
    Radio,
    Checkbox,
    Row,
    Col,
    Tag,
    Tabs,
} from 'antd'

/**
 * 验证是否是10的倍数
 */
const validateEntryFee = (rule, value, callback) => {
    if (value % 10 !== 0) {
        callback('请输入10的倍数！')
    } else {
        callback()
    }
}

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf('day')
}

// 表单数据
const formData = {
    name: {
        zh: undefined, // 中文繁体
        th: undefined, // 泰文
        vn: undefined, // 越南文
        id: undefined, // 印尼文
        pt: undefined, // 葡萄牙文
        ko: undefined, // 韩文
        spa: undefined, // 西班牙文
        lao: undefined, // 老挝语
        my: undefined, // 缅甸语
        jp: undefined, // 日文
        bn: undefined, // 孟加拉语
        rs: undefined, // 俄罗斯语
        tr: undefined, // 土耳其语
    },
    desc: {
        zh: undefined, // 中文繁体
        th: undefined, // 泰文
        vn: undefined, // 越南文
        id: undefined, // 印尼文
        pt: undefined, // 葡萄牙文
        ko: undefined, // 韩文
        spa: undefined, // 西班牙文
        lao: undefined, // 老挝语
        my: undefined, // 缅甸语
        jp: undefined, // 日文
        bn: undefined, // 孟加拉语
        rs: undefined, // 俄罗斯语
        tr: undefined, // 土耳其语
    },
    match_type: false,
    match_type_radio: undefined,
    parent_mid: undefined,
    ticket_conf_id: undefined,
    entry_fee: 0,
    fee_rate: 0,
    rebuy_count: 0,
    player_min: 2,
    rebuy_fee: 0,
    rebuy_base_time: 0,
    block_simulator: false,
    show_cowboy: false,
    addon: false,
    addon_fee: 0,
    addon_base_time: 0,
    blind_type: 1,
    entry_chips: 0,
    raise_blind_interval1: 0,
    raise_blind_interval2: 0,
    raise_blind_interval3: 0,
    delay_reg_level: 0,
    seat_num: 0,
    bonus_type: 1,
    bonus_detail: [1000],
    total_bonus_detail: 1000,
    min_ticket: 1,
    min_bonus: 0,
    startup_kind: -1,
    begin_full_time: moment().add(15, 'minutes'),
    begin_date_range: [moment().add(1, 'days'), moment().add(29, 'days')],
    begin_weeks: [1],
    begin_time: moment('00:00', 'HH:mm'),
    before_time: 10,
}

let timer
export default class MttCreate extends React.Component {
    state = {
        show: false, // 导入弹窗
        type: undefined, // 类型
        title: undefined, // 标题
        statusList: statusList, // 状态列表
        blindTypesList: blindTypesList, // 盲注结构
        bonusTypesList: bonusTypesList, // 奖池分配类型列表
        publishTypeList: publishTypeList, // 发布类型
        weekList: weekList, // 星期列表
        languageTypeList: languageTypeList, // 语言类型列表
        matchTypeList: [ // 比赛类型
            { label: '指定比赛', value: 1 },
            { label: '门票', value: 2 },
            // todo
        ],
        kind: 5, // 类型
        configData: {}, // 配置数据
        ticketList: [], // 门票列表
        matchList: [], // 比赛列表
        mttConfigList: [], // mtt配置列表
        formData: formData, // 表单数据
        diamondBalance: 0, // 余额数据
        activeNameKey: 'zh', // 激活的名称tab
    }

    componentDidMount () {
        this.fetchConfigData()
        this.fetchTicketList()
        this.fetchMatchList()
        this.fetchDiamondBalance()
    }

    /**
     * 获取配置数据
     */
    fetchConfigData = () => {
        axios
            .get('/v1/api/default_create_match_conf', {
                params: { kind: this.state.kind },
            })
            .then((res) => {
                if (res.code === 1) {
                    this.setState(
                        {
                            configData: res.data || {},
                        },
                        () => {
                            const type = this.props.location.search
                                ? 'edit'
                                : 'add'
                            if (type === 'edit') {
                                // 编辑
                                const formData =
                                    this.props.location.search.split(
                                        '?data='
                                    )[1]
                                        ? JSON.parse(
                                            decodeURIComponent(
                                                this.props.location.search.split(
                                                    '?data='
                                                )[1]
                                            )
                                        )
                                        : undefined
                                if (formData) this.handleInitFormData(type, formData)
                            }
                        }
                    )
                }
            })
    }

    /**
     * 获取门票列表
     */
    fetchTicketList = () => {
        axios.get('/v1/api/mtt/ticket/conf_list_for_activity?all=1').then((res) => {
            this.setState({
                ticketList: res.data || [],
            })
        })
    }

    /**
     * 获取比赛列表
     */
    fetchMatchList = () => {
        axios.get('/v1/api/mtt_next_match_list').then((res) => {
            this.setState({
                matchList: res.data || [],
            })
        })
    }

    /**
     * 获取余额数据
     */
    fetchDiamondBalance = async () => {
        const res = await axios.get('/v1/api/union_club_user_wallet')
        this.setState({
            diamondBalance: res.data.diamond || 0,
        })
    }

    /**
     * 获取mtt配置列表
     */
    fetchMttConfigList = () => {
        // 轮询获取所有配置列表
        let page_size = 1
        let limit = 40
        let isLoading = false
        timer = setInterval(() => {
            if (isLoading) return
            isLoading = true
            axios
                .get('/v1/api/mtt/list', {
                    params: {
                        page_size,
                        limit,
                        status: -1,
                    },
                })
                .then((res) => {
                    page_size++
                    res.data = res.data || []
                    this.setState({
                        mttConfigList: this.state.mttConfigList.concat(
                            res.data
                        ),
                    })
                    isLoading = false
                    if (res.data.length < limit) {
                        clearInterval(timer)
                    }
                })
        })
    }

    /**
     * 切换激活的名称tab
     */
    handleChangeActiveNameKey = (value) => {
        this.setState({ activeNameKey: value })
    }

    /**
     * 新增、删除固定奖金
     */
    handelOperationBoundsDetail = (type) => {
        setTimeout(() => {
            let bonus_detail =
                this.formRef.props.form.getFieldValue('bonus_detail')
            if (type === 'add') {
                bonus_detail = [
                    ...this.state.formData.bonus_detail,
                    Math.floor(bonus_detail[bonus_detail.length - 1] / 2),
                ]
                this.setState({
                    formData: {
                        ...this.state.formData,
                        bonus_detail: bonus_detail,
                        total_bonus_detail: bonus_detail.reduce(
                            (acc, cur) => acc + cur,
                            0
                        ),
                    },
                })
            } else if (type === 'delete') {
                bonus_detail = this.state.formData.bonus_detail.splice(
                    0,
                    this.state.formData.bonus_detail.length - 1
                )
                this.setState({
                    formData: {
                        ...this.state.formData,
                        bonus_detail: bonus_detail,
                        total_bonus_detail: bonus_detail.reduce(
                            (acc, cur) => acc + cur,
                            0
                        ),
                    },
                })
            } else if (type === 'change') {
                this.setState({
                    formData: {
                        ...this.state.formData,
                        bonus_detail: bonus_detail,
                        total_bonus_detail: bonus_detail.reduce(
                            (acc, cur) => acc + cur,
                            0
                        ),
                    },
                })
            }
        })
    }

    /**
     * 初始化表单数据
     */
    handleInitFormData = (type, item) => {
        this.formRef.props.form.resetFields()
        const title =
            type === 'add'
                ? this.props.language['createMttMatch']
                : this.props.language['editMttMatch']
        item.startup_setting = item.startup_setting || {}
        // 回显表单数据
        item = {
            mid: item.mid_,
            name: item.name_i18n,
            desc: item.desc_i18n,
            is_clone: item.is_clone,
            match_type: item.match_type === 1,
            match_type_radio: (() => {
                if (item.match_type === 1) {
                    if (item.parent_mid) {
                        return 1
                    } else if (item.ticket_conf_id) {
                        return 2
                    }
                }
                return undefined
            })(),
            parent_mid: item.match_type === 1 && item.parent_mid ? item.parent_mid : formData.parent_mid,
            ticket_conf_id: item.match_type === 1 && item.ticket_conf_id ? item.ticket_conf_id : formData.ticket_conf_id,
            entry_fee: item.entry_fee,
            fee_rate: this.state.configData.conf.feeRates.findIndex(
                (value) => value === item.fee_rate
            ),
            rebuy_count: this.state.configData.conf.rebuyCounts.findIndex(
                (value) => value === item.rebuy_times
            ),
            player_min: item.player_min,
            rebuy_fee: item.rebuy_fee,
            rebuy_base_time:
                this.state.configData.conf.rebuyBaseTimes.findIndex(
                    (value) => value === item.rebuy_base_time
                ),
            block_simulator: !!item.block_simulator,
            show_cowboy: !!item.show_cowboy,
            addon: item.addon_base_time > 0,
            addon_fee:
                item.addon_base_time > 0 ? item.addon_fee : formData.addon_fee,
            addon_base_time:
                item.addon_base_time > 0
                    ? this.state.configData.conf.addonBaseTimes.findIndex(
                        (value) => value === item.addon_base_time
                    )
                    : 0,
            blind_type: item.blind_type,
            entry_chips: this.state.configData.conf.entryChips.findIndex(
                (value) => value === item.entry_chips
            ),
            raise_blind_interval1:
                this.state.configData.conf.blindUpIntervals.findIndex(
                    (value) =>
                        value ===
                        (item.raise_blind_interval < 10000
                            ? item.raise_blind_interval
                            : Number(
                                String(item.raise_blind_interval).slice(-2)
                            ) * 60)
                ),
            raise_blind_interval2:
                this.state.configData.conf.blindUpIntervals.findIndex(
                    (value) =>
                        value ===
                        (item.raise_blind_interval < 10000
                            ? item.raise_blind_interval
                            : Number(
                                String(item.raise_blind_interval).slice(
                                    -4,
                                    -2
                                )
                            ) * 60)
                ),
            raise_blind_interval3:
                this.state.configData.conf.blindUpIntervals.findIndex(
                    (value) =>
                        value ===
                        (item.raise_blind_interval < 10000
                            ? item.raise_blind_interval
                            : Number(
                                String(item.raise_blind_interval).slice(
                                    -6,
                                    -4
                                )
                            ) * 60)
                ),
            delay_reg_level:
                this.state.configData.conf.delayEntryLevels.findIndex(
                    (value) => value === item.delay_reg_level
                ),
            seat_num: this.state.configData.conf.seatNums.findIndex(
                (value) => value === item.seat_num
            ),
            bonus_type: item.bonus_type,
            bonus_detail:
                item.bonus_type ===
                    this.state.bonusTypesList[
                        this.state.bonusTypesList.length - 1
                    ].value && item.bonus_detail
                    ? Object.values(JSON.parse(item.bonus_detail)).map(
                        (item) => item / 100
                    )
                    : formData.bonus_detail,
            min_ticket: item.min_ticket,
            min_bonus: item.min_bonus,
            startup_kind: item.startup_kind,
            begin_full_time:
                item.startup_kind === -1 || item.startup_kind === 0
                    ? moment(item.begin_time)
                    : formData.begin_full_time,
            begin_date_range:
                item.startup_kind === 1 || item.startup_kind === 2
                    ? [
                        moment(
                            item.startup_setting.begin_date,
                            'YYYY-MM-DD'
                        ),
                        moment(item.startup_setting.end_date, 'YYYY-MM-DD'),
                    ]
                    : formData.begin_date_range,
            begin_weeks:
                item.startup_kind === 2
                    ? item.startup_setting.week_day
                    : formData.begin_weeks,
            begin_time:
                item.startup_kind === 1 || item.startup_kind === 2
                    ? moment(item.startup_setting.moment, 'HH:mm')
                    : formData.begin_time,
            before_time:
                item.startup_kind !== -1
                    ? item.startup_setting.before_time
                    : formData.before_time,
        }
        this.setState(
            {
                formData: item,
            },
            () => {
                this.setState({
                    type,
                    title,
                })
            }
        )
    }

    /**
     * 导入赛事配置
     */
    handleImportMatchConfig = () => {
        this.importFormRef.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.state.mttConfigList.find(
                    (item) => item.mid_ === values.mid
                )
                this.handleInitFormData(this.state.type, {
                    ...formData,
                    mid_: this.state.formData.mid,
                    is_clone: this.state.formData.is_clone,
                })
                message.success(this.props.language['importSuccessMessage'])
                this.handleClose()
            }
        })
    }

    /**
     * 添加、编辑
     */
    handleAddOrEdit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post('/v1/api/create_mtt_match_conf', {
                        mid:
                            this.state.type === 'edit'
                                ? this.state.formData.mid
                                : undefined,
                        kind: this.state.kind,
                        name: JSON.stringify(values.name),
                        desc: JSON.stringify(values.desc),
                        match_type: values.match_type ? 1 : 0,
                        entry_fee: values.entry_fee,
                        fee_rate:
                            this.state.configData.conf.feeRates[
                            values.fee_rate
                            ],
                        parent_mid: values.match_type && values.match_type_radio === 1
                            ? values.parent_mid
                            : undefined,
                        ticket_conf_id: values.match_type && values.match_type_radio === 2
                            ? values.ticket_conf_id
                            : undefined,
                        rebuy_count:
                            this.state.configData.conf.rebuyCounts[
                            values.rebuy_count
                            ],
                        player_min: values.player_min,
                        rebuy_fee: values.rebuy_fee,
                        rebuy_base_time:
                            this.state.configData.conf.rebuyBaseTimes[
                            values.rebuy_base_time
                            ],
                        block_simulator: values.block_simulator,
                        show_cowboy: values.show_cowboy,
                        addon_fee: values.addon ? values.addon_fee : undefined,
                        addon_base_time: values.addon
                            ? this.state.configData.conf.addonBaseTimes[
                            values.addon_base_time
                            ]
                            : undefined,
                        blind_type: values.blind_type,
                        entry_chips:
                            this.state.configData.conf.entryChips[
                            values.entry_chips
                            ],
                        raise_blind_interval: Number(
                            String(
                                this.state.configData.conf.blindUpIntervals[
                                values.raise_blind_interval3
                                ] / 60
                            ).padStart(2, '0') +
                            String(
                                this.state.configData.conf.blindUpIntervals[
                                values.raise_blind_interval2
                                ] / 60
                            ).padStart(2, '0') +
                            String(
                                this.state.configData.conf.blindUpIntervals[
                                values.raise_blind_interval1
                                ] / 60
                            ).padStart(2, '0')
                        ),
                        delay_reg_level:
                            this.state.configData.conf.delayEntryLevels[
                            values.delay_reg_level
                            ],
                        seat_num:
                            this.state.configData.conf.seatNums[
                            values.seat_num
                            ],
                        bonus_type: values.bonus_type,
                        bonus_detail:
                            values.bonus_type ===
                                this.state.bonusTypesList[
                                    this.state.bonusTypesList.length - 1
                                ].value && values.bonus_detail
                                ? JSON.stringify(values.bonus_detail)
                                : '[]',
                        min_ticket: values.match_type
                            ? values.min_ticket
                            : undefined,
                        min_bonus: !values.match_type
                            ? values.min_bonus
                            : undefined,
                        startup_kind: values.startup_kind,
                        startup_setting: {
                            begin_date:
                                values.startup_kind === -1 ||
                                    values.startup_kind === 0
                                    ? moment(values.begin_full_time).format(
                                        'YYYY-MM-DD'
                                    )
                                    : moment(values.begin_date_range[0]).format(
                                        'YYYY-MM-DD'
                                    ),
                            end_date:
                                values.startup_kind === -1 ||
                                    values.startup_kind === 0
                                    ? moment(values.begin_full_time).format(
                                        'YYYY-MM-DD'
                                    )
                                    : moment(values.begin_date_range[1]).format(
                                        'YYYY-MM-DD'
                                    ),
                            moment:
                                values.startup_kind === -1 ||
                                    values.startup_kind === 0
                                    ? moment(values.begin_full_time).format(
                                        'HH:mm'
                                    )
                                    : moment(values.begin_time).format('HH:mm'),
                            week_day:
                                values.startup_kind === 2
                                    ? values.begin_weeks
                                    : [],
                            before_time:
                                values.startup_kind !== -1
                                    ? values.before_time
                                    : 0,
                        },
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            if (this.state.type === 'edit') {
                                message.success(
                                    this.props.language['editSuccessMessage']
                                )
                            } else {
                                message.success(
                                    this.props.language['createSuccessMessage']
                                )
                            }
                            this.handleClosePage()
                        }
                    })
            } else {
                if (err.name) {
                    for (const item of languageTypeList) {
                        for (const key of Object.keys(err.name)) {
                            if (item.value === key) return this.handleChangeActiveNameKey(key)
                        }
                    }
                }
            }
        })
    }

    /**
     * 显示弹窗
     */
    handleShow = () => {
        // 导入配置
        this.setState({ show: true, mttConfigList: [] })
        this.fetchMttConfigList()
    }

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.importFormRef.props.form.resetFields()
        this.setState({ show: false })
    }

    /**
     * 关闭页面
     */
    handleClosePage = () => {
        this.props.history.push('/mtt_list')
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <h2>{this.state.title}</h2>
                    <h3>
                        {this.state.configData.kind && (
                            <span style={{ color: '#ff4d4f' }}>
                                （
                                {this.state.configData.conf &&
                                    this.state.configData.conf.costRateDiscount ===
                                    0 ? (
                                    <span>
                                        {this.props.language['freeLimitedTime']}
                                    </span>
                                ) : (
                                    <span>
                                        <span>
                                            {
                                                this.props.language[
                                                'everyHoursConsumeDiamond'
                                                ]
                                            }
                                            ：
                                        </span>
                                        <span
                                            style={{
                                                textDecoration: 'line-through',
                                            }}
                                        >
                                            {
                                                this.props.language[
                                                'originalPrice'
                                                ]
                                            }
                                            :
                                            {
                                                this.state.configData.conf
                                                    .costRate
                                            }
                                        </span>
                                        ；
                                        <span>
                                            {
                                                this.props.language[
                                                'currentPrice'
                                                ]
                                            }
                                            :
                                            {
                                                this.state.configData.conf
                                                    .costRateDiscount
                                            }
                                        </span>
                                    </span>
                                )}
                                ）
                            </span>
                        )}
                    </h3>
                    <Button type="danger">
                        {this.props.language['diamondBalance']}：
                        {this.state.diamondBalance}
                    </Button>
                    {!this.state.formData.is_clone && (
                        <Button type="primary" ghost onClick={this.handleShow}>
                            {this.props.language['importMatchConfig']}
                        </Button>
                    )}
                </div>

                {/* 内容 */}
                <div className="container-content mb10">
                    {/* 表单内容 */}
                    <FormModal
                        {...this.props}
                        formData={this.state.formData}
                        configData={this.state.configData}
                        ticketList={this.state.ticketList}
                        matchList={this.state.matchList}
                        blindTypesList={this.state.blindTypesList}
                        bonusTypesList={this.state.bonusTypesList}
                        publishTypeList={this.state.publishTypeList}
                        matchTypeList={this.state.matchTypeList}
                        weekList={this.state.weekList}
                        rankingNumber={this.state.rankingNumber}
                        activeNameKey={this.state.activeNameKey}
                        handleChangeActiveNameKey={this.handleChangeActiveNameKey}
                        handelOperationBoundsDetail={
                            this.handelOperationBoundsDetail
                        }
                        onOk={this.handleAddOrEdit}
                        onCancel={this.handleClosePage}
                        wrappedComponentRef={(formRef) =>
                            (this.formRef = formRef)
                        }
                    />

                    {/* 导入配置弹窗 */}
                    <ImprotFormModal
                        {...this.props}
                        visible={this.state.show}
                        mttConfigList={this.state.mttConfigList}
                        publishTypeList={this.state.publishTypeList}
                        onOk={this.handleImportMatchConfig}
                        onCancel={this.handleClose}
                        wrappedComponentRef={(importFormRef) =>
                            (this.importFormRef = importFormRef)
                        }
                    />
                </div>
            </div>
        )
    }
}

/**
 * 编辑、创建表单弹窗
 */
const FormModal = Form.create({ name: 'form_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form
            return (
                <div
                    className="container-content pb0"
                    style={{
                        maxWidth: 600,
                        border: '1px solid #e8e8e8',
                        borderRadius: 4,
                        margin: '0 auto',
                    }}
                >
                    {this.props.configData.kind && (
                        <Form>
                            {/* 赛事名称*/}
                            <p className='form-label form-label-required'>{this.props.language['matchName']}</p>
                            <Tabs activeKey={this.props.activeNameKey} onChange={(value) => this.props.handleChangeActiveNameKey(value)}>
                                {languageTypeList.map((item, index) =>
                                    <Tabs.TabPane tab={item.label} key={item.value}>
                                        <Form.Item>
                                            {getFieldDecorator(`name.${item.value}`, {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'matchNameVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue: this.props.formData.name[item.value],
                                            })(
                                                <Input
                                                    maxLength={16}
                                                    allowClear
                                                    placeholder={
                                                        this.props.language[
                                                        'matchNamePlaceholder'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </Tabs.TabPane>
                                )}
                            </Tabs>

                            {/* 赛事说明 */}
                            <p className='form-label'>{this.props.language['matchDescription']}</p>
                            <Tabs>
                                {languageTypeList.map((item, index) =>
                                    <Tabs.TabPane tab={item.label} key={item.value}>
                                        <Form.Item>
                                            {getFieldDecorator(`desc.${item.value}`, {
                                                rules: [
                                                    {
                                                        required: false,
                                                        message:
                                                            this.props.language[
                                                            'matchDescriptionVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue: this.props.formData.desc[item.value],
                                            })(
                                                <Input.TextArea
                                                    rows={4}
                                                    maxLength={45}
                                                    allowClear
                                                    placeholder={
                                                        this.props.language[
                                                        'matchDescriptionPlaceholder'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </Tabs.TabPane>
                                )}
                            </Tabs>

                            {/* 盲注结构 */}
                            <Form.Item label={this.props.language['blindType']}>
                                {getFieldDecorator('blind_type', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'blindTypeVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.blind_type,
                                })(
                                    <Radio.Group>
                                        {this.props.blindTypesList.map(
                                            (item, index) => (
                                                <Radio
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>

                            {/* 卫星赛 */}
                            <Form.Item
                                label={this.props.language['satelliteGames']}
                            >
                                {getFieldDecorator('match_type', {
                                    initialValue:
                                        this.props.formData.match_type,
                                    valuePropName: 'checked',
                                })(<Switch />)}
                            </Form.Item>
                            {(getFieldValue('match_type') !== undefined ? getFieldValue("match_type") : this.props.formData.match_type) && (
                                <>
                                    {/* 类型 */}
                                    <Form.Item label={this.props.language['type']}>
                                        {getFieldDecorator('match_type_radio', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'typeVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue: this.props.formData.match_type_radio,
                                        })(
                                            <Radio.Group>
                                                {this.props.matchTypeList.map(
                                                    (item, index) => (
                                                        <Radio
                                                            key={index}
                                                            value={item.value}
                                                        >
                                                            {item.label}
                                                        </Radio>
                                                    )
                                                )}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>

                                    {/* 指定比赛 */}
                                    {(getFieldValue('match_type_radio') !== undefined ? getFieldValue("match_type_radio") : this.props.formData.match_type_radio) === 1 && (
                                        <Form.Item
                                            label={this.props.language['nextMatch']}
                                        >
                                            {getFieldDecorator('parent_mid', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'nextMatchVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData.parent_mid,
                                            })(
                                                <Select
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder={
                                                        this.props.language[
                                                        'nextMatchPlaceholder'
                                                        ]
                                                    }
                                                >
                                                    {this.props.matchList.map(
                                                        (item, index) => (
                                                            <Select.Option
                                                                key={index}
                                                                value={item.mid_}
                                                            >
                                                                {item.name_cn}（
                                                                {item.begin_time}
                                                                ）$:{item.entry_fee}
                                                            </Select.Option>
                                                        )
                                                    )}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    )}

                                    {/* 门票 */}
                                    {(getFieldValue('match_type_radio') !== undefined ? getFieldValue("match_type_radio") : this.props.formData.match_type_radio) === 2 && (
                                        <Form.Item
                                            label={this.props.language['ticket']}
                                        >
                                            {getFieldDecorator('ticket_conf_id', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'ticketVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData.ticket_conf_id,
                                            })(
                                                <Select
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    placeholder={
                                                        this.props.language[
                                                        'ticketPlaceholder'
                                                        ]
                                                    }
                                                >
                                                    {this.props.ticketList.map(
                                                        (item, index) => (
                                                            <Select.Option
                                                                key={index}
                                                                value={item.id}
                                                            >
                                                                {item.name}（{item.ticket_value}）（{item.id}）
                                                            </Select.Option>
                                                        )
                                                    )}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    )}
                                </>
                            )}

                            {/* 保底门票 */}
                            {(getFieldValue('match_type') !== undefined ? getFieldValue("match_type") : this.props.formData.match_type) ? (
                                <Form.Item
                                    label={this.props.language['minTicket']}
                                >
                                    {getFieldDecorator('min_ticket', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'minTicketVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue:
                                            this.props.formData.min_ticket,
                                    })(
                                        <InputNumber
                                            min={0}
                                            max={100000000}
                                            precision={0}
                                            placeholder={
                                                this.props.language[
                                                'minTicketPlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                            ) : (
                                <Form.Item
                                    label={
                                        this.props.language['minPrizePool'] +
                                        this.props.language[
                                        'counterDeductionFix'
                                        ]
                                    }
                                >
                                    {getFieldDecorator('min_bonus', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    this.props.language[
                                                    'prizePoolVerify'
                                                    ],
                                            },
                                        ],
                                        initialValue:
                                            this.props.formData.min_bonus,
                                    })(
                                        <InputNumber
                                            min={0}
                                            max={100000000}
                                            precision={0}
                                            placeholder={
                                                this.props.language[
                                                'prizePoolPlaceholder'
                                                ]
                                            }
                                        />
                                    )}
                                </Form.Item>
                            )}

                            {/* Addon */}
                            <Form.Item label="Addon">
                                {getFieldDecorator('addon', {
                                    initialValue: this.props.formData.addon,
                                    valuePropName: 'checked',
                                })(<Switch />)}
                            </Form.Item>
                            {(getFieldValue('addon') !== undefined ? getFieldValue("addon") : this.props.formData.addon) && (
                                <>
                                    <Form.Item
                                        label={
                                            this.props.language['addonFee'] +
                                            this.props.language[
                                            'tenMultipleFix'
                                            ]
                                        }
                                    >
                                        {getFieldDecorator('addon_fee', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'addonFeeVerify'
                                                        ],
                                                },
                                                { validator: validateEntryFee },
                                            ],
                                            initialValue:
                                                this.props.formData.addon_fee,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100000000}
                                                step={10}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'addonFeePlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span>
                                                {
                                                    this.props.language[
                                                    'addonChipVerify'
                                                    ]
                                                }
                                                {
                                                    this.props.language[
                                                    'initChipFix'
                                                    ]
                                                }
                                                ：
                                                {this.props.configData.conf
                                                    .addonBaseTimes[
                                                    getFieldValue('addon_base_time') !== undefined ? getFieldValue("addon_base_time") : this.props.formData.addon_base_time
                                                ] / 100}
                                                x
                                            </span>
                                        }
                                    >
                                        {getFieldDecorator('addon_base_time', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'addonChipVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData
                                                    .addon_base_time,
                                        })(
                                            <Slider
                                                dots
                                                tipFormatter={(value) =>
                                                    String(
                                                        this.props.configData
                                                            .conf
                                                            .addonBaseTimes[
                                                        value
                                                        ] /
                                                        100 +
                                                        'x'
                                                    )
                                                }
                                                min={0}
                                                max={
                                                    this.props.configData.conf
                                                        .addonBaseTimes.length -
                                                    1
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 禁用模拟器 */}
                            <Form.Item
                                label={this.props.language['disableSimulator']}
                            >
                                {getFieldDecorator('block_simulator', {
                                    initialValue:
                                        this.props.formData.block_simulator,
                                    valuePropName: 'checked',
                                })(<Switch />)}
                            </Form.Item>

                            {/* 房间内Cowboy */}
                            <Form.Item
                                label={
                                    <>
                                        <span>
                                            {
                                                this.props.language[
                                                'isRoomCowboy'
                                                ]
                                            }
                                        </span>
                                        <span style={{ color: '#ff4d4f' }}>
                                            （
                                            {this.props.configData.conf
                                                .cowboyCostRateDiscount ===
                                                0 ? (
                                                <span>
                                                    {
                                                        this.props.language[
                                                        'freeLimitedTime'
                                                        ]
                                                    }
                                                </span>
                                            ) : (
                                                <span>
                                                    <span>
                                                        {
                                                            this.props.language[
                                                            'everyHoursConsumeDiamond'
                                                            ]
                                                        }
                                                        ：
                                                    </span>
                                                    <span
                                                        style={{
                                                            textDecoration:
                                                                'line-through',
                                                            marginRight: 5,
                                                        }}
                                                    >
                                                        {
                                                            this.props.language[
                                                            'originalPrice'
                                                            ]
                                                        }
                                                        ：
                                                        {
                                                            this.props
                                                                .configData.conf
                                                                .cowboyCostRate
                                                        }
                                                    </span>
                                                    ；
                                                    <span>
                                                        {
                                                            this.props.language[
                                                            'currentPrice'
                                                            ]
                                                        }
                                                        ：
                                                        {
                                                            this.props
                                                                .configData.conf
                                                                .cowboyCostRateDiscount
                                                        }
                                                    </span>
                                                </span>
                                            )}
                                            ）
                                        </span>
                                    </>
                                }
                            >
                                {getFieldDecorator('show_cowboy', {
                                    initialValue:
                                        this.props.formData.show_cowboy,
                                    valuePropName: 'checked',
                                })(<Switch />)}
                            </Form.Item>

                            {/* 报名费 */}
                            <Form.Item
                                label={
                                    this.props.language['applyFee'] +
                                    this.props.language['tenMultipleFix']
                                }
                            >
                                {getFieldDecorator('entry_fee', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'applyFeeVerify'
                                                ],
                                        },
                                        { validator: validateEntryFee },
                                    ],
                                    initialValue: this.props.formData.entry_fee,
                                })(
                                    <InputNumber
                                        min={0}
                                        max={100000000}
                                        step={10}
                                        precision={0}
                                        placeholder={
                                            this.props.language[
                                            'applyFeePlaceholder'
                                            ]
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 最低开赛人数 */}
                            <Form.Item
                                label={
                                    this.props.language['minStartMatchPeople']
                                }
                            >
                                {getFieldDecorator('player_min', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'minStartMatchPeopleVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.player_min,
                                })(
                                    <InputNumber
                                        min={2}
                                        max={100000000}
                                        precision={0}
                                        placeholder={
                                            this.props.language[
                                            'minStartMatchPeoplePlaceholder'
                                            ]
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* Rebuy费用(10的整数倍) */}
                            <Form.Item
                                label={
                                    this.props.language['rebuyFee'] +
                                    this.props.language['tenMultipleFix']
                                }
                            >
                                {getFieldDecorator('rebuy_fee', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'rebuyFeeVerify'
                                                ],
                                        },
                                        { validator: validateEntryFee },
                                    ],
                                    initialValue: this.props.formData.rebuy_fee,
                                })(
                                    <InputNumber
                                        min={0}
                                        max={100000000}
                                        step={10}
                                        precision={0}
                                        placeholder={
                                            this.props.language[
                                            'rebuyFeePlaceholder'
                                            ]
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* Rebuy次数 */}
                            <Form.Item
                                label={
                                    <span>
                                        {this.props.language['rebuyTime']}：
                                        {
                                            this.props.configData.conf
                                                .rebuyCounts[
                                            getFieldValue('rebuy_count') !== undefined ? getFieldValue("rebuy_count") : this.props.formData.rebuy_count
                                            ]
                                        }
                                        {this.props.language['count']}
                                    </span>
                                }
                            >
                                {getFieldDecorator('rebuy_count', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'rebuyTimeVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.rebuy_count,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .rebuyCounts[value]
                                            ) + this.props.language['count']
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .rebuyCounts.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* Rebuy筹码(x初始筹码) */}
                            <Form.Item
                                label={
                                    <span>
                                        {this.props.language['rebuyChip']}
                                        {this.props.language['initChipFix']}：
                                        {this.props.configData.conf
                                            .rebuyBaseTimes[
                                            getFieldValue('rebuy_base_time') !== undefined ? getFieldValue("rebuy_base_time") : this.props.formData.rebuy_base_time
                                        ] / 100}
                                        x
                                    </span>
                                }
                            >
                                {getFieldDecorator('rebuy_base_time', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'rebuyChipVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.rebuy_base_time,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .rebuyBaseTimes[value] /
                                                100 +
                                                'x'
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .rebuyBaseTimes.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 服务费 */}
                            <Form.Item
                                label={
                                    <span>
                                        {this.props.language['serviceFee']}：
                                        {this.props.configData.conf.feeRates[
                                            getFieldValue('fee_rate') !== undefined ? getFieldValue("fee_rate") : this.props.formData.fee_rate
                                        ] / 100}
                                        %
                                    </span>
                                }
                            >
                                {getFieldDecorator('fee_rate', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'serviceFeeVerify'
                                                ],
                                        },
                                    ],
                                    initialValue: this.props.formData.fee_rate,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .feeRates[value] /
                                                100 +
                                                '%'
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf.feeRates
                                                .length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 初始筹码 */}
                            <Form.Item
                                label={
                                    <span>
                                        {this.props.language['initChip']}：
                                        {this.props.configData.conf.entryChips[
                                            getFieldValue('entry_chips') !== undefined ? getFieldValue("entry_chips") : this.props.formData.entry_chips
                                        ] / 100}
                                    </span>
                                }
                            >
                                {getFieldDecorator('entry_chips', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'initChipVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.entry_chips,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .entryChips[value] / 100
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .entryChips.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 涨盲时间（截至报名前） */}
                            <Form.Item
                                label={
                                    <span>
                                        {
                                            this.props.language[
                                            'blindTimeApplyStart'
                                            ]
                                        }
                                        ：
                                        {this.props.configData.conf
                                            .blindUpIntervals[
                                            getFieldValue('raise_blind_interval1') !== undefined ? getFieldValue("raise_blind_interval1") : this.props.formData.raise_blind_interval1
                                        ] / 60}
                                        {this.props.language['minute']}
                                    </span>
                                }
                            >
                                {getFieldDecorator('raise_blind_interval1', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'blindTimeFinallyVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData
                                            .raise_blind_interval1,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .blindUpIntervals[value] /
                                                60 +
                                                this.props.language[
                                                'minute'
                                                ]
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .blindUpIntervals.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 涨盲时间（截至报名后） */}
                            <Form.Item
                                label={
                                    <span>
                                        {
                                            this.props.language[
                                            'blindTimeApplyEnd'
                                            ]
                                        }
                                        ：
                                        {this.props.configData.conf
                                            .blindUpIntervals[
                                            getFieldValue('raise_blind_interval2') !== undefined ? getFieldValue("raise_blind_interval2") : this.props.formData.raise_blind_interval2
                                        ] / 60}
                                        {this.props.language['minute']}
                                    </span>
                                }
                            >
                                {getFieldDecorator('raise_blind_interval2', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'blindTimeFinallyVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData
                                            .raise_blind_interval2,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .blindUpIntervals[value] /
                                                60 +
                                                this.props.language[
                                                'minute'
                                                ]
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .blindUpIntervals.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 涨盲时间（决赛桌） */}
                            <Form.Item
                                label={
                                    <span>
                                        {
                                            this.props.language[
                                            'blindTimeFinally'
                                            ]
                                        }
                                        ：
                                        {this.props.configData.conf
                                            .blindUpIntervals[
                                            getFieldValue('raise_blind_interval3') !== undefined ? getFieldValue("raise_blind_interval3") : this.props.formData.raise_blind_interval3
                                        ] / 60}
                                        {this.props.language['minute']}
                                    </span>
                                }
                            >
                                {getFieldDecorator('raise_blind_interval3', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'blindTimeFinallyVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData
                                            .raise_blind_interval3,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .blindUpIntervals[value] /
                                                60 +
                                                this.props.language[
                                                'minute'
                                                ]
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .blindUpIntervals.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 截至报名(级别) */}
                            <Form.Item
                                label={
                                    <span>
                                        {this.props.language['deadlineApply']}
                                        {this.props.language['levelsuFix']}：
                                        {
                                            this.props.configData.conf
                                                .delayEntryLevels[
                                            getFieldValue('delay_reg_level') !== undefined ? getFieldValue("delay_reg_level") : this.props.formData.delay_reg_level
                                            ]
                                        }
                                    </span>
                                }
                            >
                                {getFieldDecorator('delay_reg_level', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'deadlineApplyVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.delay_reg_level,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .delayEntryLevels[value]
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf
                                                .delayEntryLevels.length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 单桌座位数 */}
                            <Form.Item
                                label={
                                    <span>
                                        {
                                            this.props.language[
                                            'singleSeatNumber'
                                            ]
                                        }
                                        ：
                                        {
                                            this.props.configData.conf.seatNums[
                                            getFieldValue('seat_num') !== undefined ? getFieldValue("seat_num") : this.props.formData.seat_num
                                            ]
                                        }
                                    </span>
                                }
                            >
                                {getFieldDecorator('seat_num', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'singleSeatNumberVerify'
                                                ],
                                        },
                                    ],
                                    initialValue: this.props.formData.seat_num,
                                })(
                                    <Slider
                                        dots
                                        tipFormatter={(value) =>
                                            String(
                                                this.props.configData.conf
                                                    .seatNums[value]
                                            )
                                        }
                                        min={0}
                                        max={
                                            this.props.configData.conf.seatNums
                                                .length - 1
                                        }
                                    />
                                )}
                            </Form.Item>

                            {/* 奖池分配 */}
                            <Form.Item
                                label={this.props.language['prizPooAllocation']}
                            >
                                {getFieldDecorator('bonus_type', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'prizPooAllocationVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.bonus_type,
                                })(
                                    <Radio.Group>
                                        {this.props.bonusTypesList.map(
                                            (item, index) => (
                                                <Radio
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                    {index ===
                                                        this.props
                                                            .bonusTypesList
                                                            .length -
                                                        1 &&
                                                        (getFieldValue('bonus_type') !== undefined ? getFieldValue("bonus_type") : this.props.formData.bonus_type) ===
                                                        this.props
                                                            .bonusTypesList[
                                                            this.props
                                                                .bonusTypesList
                                                                .length - 1
                                                        ].value && (
                                                            <>
                                                                （
                                                                {
                                                                    this.props
                                                                        .language[
                                                                    'aggregate'
                                                                    ]
                                                                }
                                                                ：
                                                                {
                                                                    this.props
                                                                        .formData
                                                                        .total_bonus_detail
                                                                }
                                                                ）
                                                            </>
                                                        )}
                                                </Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            {(getFieldValue('bonus_type') !== undefined ? getFieldValue("bonus_type") : this.props.formData.bonus_type) ===
                                this.props.bonusTypesList[
                                    this.props.bonusTypesList.length - 1
                                ].value && (
                                    <>
                                        {this.props.formData.bonus_detail.map(
                                            (item, index) => (
                                                <Row gutter={10} key={index}>
                                                    <Col span={16}>
                                                        <Form.Item
                                                            label={this.props.getLanguage(
                                                                'rankRewrad',
                                                                index + 1
                                                            )}
                                                            labelCol={{ span: 6 }}
                                                            wrapperCol={{
                                                                span: 18,
                                                            }}
                                                        >
                                                            {getFieldDecorator(
                                                                `bonus_detail[${index}]`,
                                                                {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                this.props.getLanguage(
                                                                                    'rankRewradVerify',
                                                                                    index +
                                                                                    1
                                                                                ),
                                                                        },
                                                                    ],
                                                                    initialValue:
                                                                        this.props
                                                                            .formData
                                                                            .bonus_detail[
                                                                        index
                                                                        ],
                                                                }
                                                            )(
                                                                <InputNumber
                                                                    min={1}
                                                                    max={100000000}
                                                                    precision={0}
                                                                    onChange={() =>
                                                                        this.props.handelOperationBoundsDetail(
                                                                            'change'
                                                                        )
                                                                    }
                                                                    placeholder={this.props.getLanguage(
                                                                        'rankRewradPlaceholder',
                                                                        index + 1
                                                                    )}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col
                                                        span={8}
                                                        style={{
                                                            marginTop:
                                                                isMobileDevice()
                                                                    ? 28
                                                                    : 4,
                                                        }}
                                                    >
                                                        {index ===
                                                            this.props.formData
                                                                .bonus_detail
                                                                .length -
                                                            1 && (
                                                                <Row
                                                                    type="flex"
                                                                    align="middle"
                                                                    gutter={5}
                                                                >
                                                                    {index > 0 && (
                                                                        <Col>
                                                                            <Button
                                                                                shape="circle"
                                                                                icon="minus"
                                                                                onClick={() =>
                                                                                    this.props.handelOperationBoundsDetail(
                                                                                        'delete'
                                                                                    )
                                                                                }
                                                                            />
                                                                        </Col>
                                                                    )}
                                                                    <Col>
                                                                        <Button
                                                                            shape="circle"
                                                                            icon="plus"
                                                                            onClick={() =>
                                                                                this.props.handelOperationBoundsDetail(
                                                                                    'add'
                                                                                )
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                    </Col>
                                                </Row>
                                            )
                                        )}
                                    </>
                                )}

                            {/* 发布类型 */}
                            <Form.Item
                                label={this.props.language['publishType']}
                            >
                                {getFieldDecorator('startup_kind', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'publishTypeVerify'
                                                ],
                                        },
                                    ],
                                    initialValue:
                                        this.props.formData.startup_kind,
                                })(
                                    <Radio.Group
                                        disabled={this.props.formData.is_clone}
                                    >
                                        {this.props.publishTypeList.map(
                                            (item, index) => (
                                                <Radio
                                                    key={index}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            {((getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === -1 ||
                                (getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 0) && (
                                    <Form.Item
                                        label={
                                            this.props.language['startMatchTime']
                                        }
                                    >
                                        {getFieldDecorator('begin_full_time', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'startMatchTimeVerify'
                                                        ],
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.begin_full_time,
                                        })(
                                            <DatePicker
                                                disabled={
                                                    this.props.formData.is_clone
                                                }
                                                disabledDate={disabledDate}
                                                showTime={{ format: 'HH:mm' }}
                                                format="YYYY-MM-DD HH:mm"
                                                placeholder={
                                                    this.props.language[
                                                    'startMatchTimePlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                )}
                            {((getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 1 ||
                                (getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 2) && (
                                    <>
                                        <Form.Item
                                            label={
                                                this.props.language[
                                                'startMatchTimeRange'
                                                ]
                                            }
                                        >
                                            {getFieldDecorator('begin_date_range', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'startMatchTimeRangeVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue:
                                                    this.props.formData
                                                        .begin_date_range,
                                            })(
                                                <DatePicker.RangePicker
                                                    disabled={
                                                        this.props.formData.is_clone
                                                    }
                                                    format="YYYY-MM-DD"
                                                />
                                            )}
                                        </Form.Item>
                                        {(getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 2 && (
                                            <Form.Item
                                                label={
                                                    this.props.language[
                                                    'startMatchTimeWeek'
                                                    ]
                                                }
                                            >
                                                {getFieldDecorator('begin_weeks', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props.language[
                                                                'startMatchTimeWeekVerify'
                                                                ],
                                                        },
                                                    ],
                                                    initialValue:
                                                        this.props.formData
                                                            .begin_weeks,
                                                })(
                                                    <Checkbox.Group
                                                        disabled={
                                                            this.props.formData
                                                                .is_clone
                                                        }
                                                    >
                                                        {this.props.weekList.map(
                                                            (item, index) => (
                                                                <Checkbox
                                                                    key={index}
                                                                    value={
                                                                        item.value
                                                                    }
                                                                >
                                                                    {item.label}
                                                                </Checkbox>
                                                            )
                                                        )}
                                                    </Checkbox.Group>
                                                )}
                                            </Form.Item>
                                        )}
                                        <Form.Item
                                            label={`${this.props.language['startMatchTime']}${this.props.language['everyDayTimeFix']}`}
                                        >
                                            {getFieldDecorator('begin_time', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language[
                                                            'startMatchTimeVerify'
                                                            ],
                                                    },
                                                ],
                                                initialValue: this.props.formData
                                                    .begin_time
                                                    ? this.props.formData.begin_time
                                                    : undefined,
                                            })(
                                                <TimePicker
                                                    disabled={
                                                        this.props.formData.is_clone
                                                    }
                                                    format="HH:mm"
                                                    placeholder={
                                                        this.props.language[
                                                        'startMatchTimePlaceholder'
                                                        ]
                                                    }
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}
                            {((getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 0 ||
                                (getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 1 ||
                                (getFieldValue('startup_kind') !== undefined ? getFieldValue("startup_kind") : this.props.formData.startup_kind) === 2) && (
                                    <Form.Item
                                        label={`${this.props.language['publishMatchTime']}${this.props.language['minuteFix']}`}
                                    >
                                        {getFieldDecorator('before_time', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language[
                                                        'publishMatchTimeVerify'
                                                        ],
                                                },
                                                {
                                                    validator: (_, value, callback) => {
                                                        if (!value) return callback()
                                                        const days =
                                                            Number(value) / 60 / 24
                                                        if (days > 7) {
                                                            return callback(this.props.language['publishMinuteLimit'])
                                                        }
                                                        return callback()
                                                    },
                                                },
                                            ],
                                            initialValue:
                                                this.props.formData.before_time,
                                        })(
                                            <InputNumber
                                                disabled={
                                                    this.props.formData.is_clone
                                                }
                                                min={10}
                                                max={100000000}
                                                precision={0}
                                                placeholder={
                                                    this.props.language[
                                                    'publishMatchTimePlaceholder'
                                                    ]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                )}
                            <Form.Item>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        className="mr10"
                                        onClick={this.props.onCancel}
                                    >
                                        {this.props.language['cancel']}
                                    </Button>
                                    <Button
                                        type="primary"
                                        onClick={this.props.onOk}
                                    >
                                        {this.props.language['confirm']}
                                    </Button>
                                </div>
                            </Form.Item>
                        </Form>
                    )}
                </div>
            )
        }
    }
)

/**
 * 导入配置弹窗
 */
const ImprotFormModal = Form.create({ name: 'import_model' })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.language['importMatchConfig']}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item
                                label={this.props.language['matchCnfig']}
                            >
                                {getFieldDecorator('mid', {
                                    rules: [
                                        {
                                            required: true,
                                            message:
                                                this.props.language[
                                                'matchCnfigVerify'
                                                ],
                                        },
                                    ],
                                })(
                                    <Select
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language[
                                            'matchCnfigPlaceholder'
                                            ]
                                        }
                                    >
                                        {this.props.mttConfigList.map(
                                            (item, index) => (
                                                <Select.Option
                                                    key={index}
                                                    value={item.mid_}
                                                >
                                                    {item.name_cn}（{item.mid_}
                                                    ）
                                                    {this.props.publishTypeList.find(
                                                        (item2) =>
                                                            item2.value ===
                                                            item.startup_kind
                                                    ) ? (
                                                        <Tag color="blue">
                                                            {this.props.publishTypeList.find(
                                                                (item2) =>
                                                                    item2.value ===
                                                                    item.startup_kind
                                                            )
                                                                ? this.props.publishTypeList.find(
                                                                    (
                                                                        item2
                                                                    ) =>
                                                                        item2.value ===
                                                                        item.startup_kind
                                                                ).label
                                                                : ''}
                                                        </Tag>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Select.Option>
                                            )
                                        )}
                                    </Select>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            )
        }
    }
)
